import React from 'react'
import Link from 'gatsby-link'
import FlagIcon from '../components/flagicon'
import moment from 'moment'
import { Card, CardBody, CardText, CardTitle } from 'reactstrap'

// import CountryCodes from 'country-code-info';
import { findCountry } from '../components/helpers/countries'
import { matchName } from '../components/helpers/matchnames'

var worldjson = require('../../node_modules/world-countries/dist/countries.json')

const ActualDayPage = props => {
  const games = props.data.allThirdPartyWorldCupMatches.edges

  function startTime(datetime) {
    return moment(datetime)
      .locale('de')
      .format('dddd DD.MM.YYYY HH:mm')
      .toString()
  }

  function searchCountryName(code) {
    for (var i = 0; i < worldjson.length; i++) {
      if (worldjson[i].cca2 == code) {
        return worldjson[i].translations.deu.common
      }
    }
  }

  return (
    <div>
      <h1>Nächste Spiele</h1>

      {games.map((game, i) => {
        const gameData = game.node
        const code1 = findCountry(gameData.home_team.code).toLowerCase()
        const code2 = findCountry(gameData.away_team.code).toLowerCase()
        const starttime = startTime(gameData.datetime)

        return (
          <Card
            key={i}
            style={{
              width: '30rem',
              'margin-bottom': '2rem',
              'margin-top': '1rem',
            }}
          >
            <CardTitle>
              <h2>
                Spiel {matchName(gameData.stage_name)}
                {gameData.status == 'completed' ? (
                  <span className="game__status">Beendet</span>
                ) : null}
              </h2>
            </CardTitle>
            <CardBody>
              <p className="game__result">
                <FlagIcon code={code1} size="3x" />&nbsp;&nbsp;&nbsp;{searchCountryName(
                  code1.toUpperCase()
                )}{' '}
                vs {searchCountryName(code2.toUpperCase())}&nbsp;&nbsp;&nbsp;<FlagIcon
                  code={code2}
                  size="3x"
                />
              </p>

              <p>Ort: {gameData.venue}</p>
              <p>Beginn: {starttime}</p>

              {gameData.status != 'future' && (
                <div>
                  <p className="game__result">
                    Ergebnis: {gameData.home_team.goals}:{
                      gameData.away_team.goals
                    }{' '}
                  </p>
                </div>
              )}
            </CardBody>
          </Card>
        )
      })}
    </div>
  )
}

export default ActualDayPage

export const query = graphql`
  query MyGamequery {
    allThirdPartyWorldCupMatches(
      limit: 2
      filter: { status: { ne: "completed" } }
    ) {
      edges {
        node {
          home_team {
            code
          }
          away_team {
            code
          }
          venue
          datetime
          stage_name
          status
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/actualday.js